// Example locale file for English, give this to your locale team to translate

const AG_GRID_LOCALE_EL = {
    // Set Filter
    selectAll: '(Επιλογή όλων)',
    selectAllSearchResults: '(Επιλογή όλων των αποτελεσμάτων αναζήτησης)',
    searchOoo: 'Αναζήτηση...',
    blanks: '(Κενό)',
    noMatches: 'Δεν ταιριάζουν',

    // Number Filter & Text Filter
    filterOoo: 'Φίλτρο...',
    equals: 'Ίσο',
    notEqual: 'Άνισο',
    empty: 'Επιλέξτε ένα',

    // Number Filter
    lessThan: 'Μικρότερο από',
    greaterThan: 'Μεγαλύτερο από',
    lessThanOrEqual: 'Μικρότερο ή ίσο',
    greaterThanOrEqual: 'Μεγαλύτερο ή ίσο',
    inRange: 'Στο έβρος',
    inRangeStart: 'από',
    inRangeEnd: 'εώς',

    // Text Filter
    contains: 'Περιέχει',
    notContains: 'Δεν περιέχει',
    startsWith: 'Ξεκινά με',
    endsWith: 'Τελειώνει με',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'και',
    orCondition: 'ή',

    // Filter Buttons
    applyFilter: 'Εφαρμογή',
    resetFilter: 'Μηδενισμός',
    clearFilter: 'Καθαρισμός',
    cancelFilter: 'Ακύρωση',

    // Filter Titles
    textFilter: 'Φίλτρο κειμένου',
    numberFilter: 'Αριθμητικό φίλτρο',
    dateFilter: 'Φίλτρο ημερομηνίας',
    setFilter: 'Επιλογή φίλτρου',

    // Side Bar
    columns: 'Στήλες',
    filters: 'Φίλτρα',

    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',

    // Header of the Default Group Column
    group: 'Group',

    // Other
    loadingOoo: 'Φορτώνει...',
    noRowsToShow: 'Δεν υπάρχουν αποτελέσματα',
    enabled: 'Ενεργό',

    // Menu
    pinColumn: 'Καρφίτσωμα Στήλης',
    pinLeft: 'Καρφίτσωμα Αριστερά',
    pinRight: 'Καρφίτσωμα Δεξιά',
    noPin: 'Χωρίς Καρφίτσωμα',
    valueAggregation: 'Συνάθροιση Αξίας',
    autosizeThiscolumn: 'Αυτόματο μέγεθος στήλης',
    autosizeAllColumns: 'Αυτόματο μέγεθος σε όλες τις στήλες',
    groupBy: 'Ομαδοποίηση',
    ungroupBy: 'Επαναφορά ομαδοποίησης',
    resetColumns: 'Επαναφορά στηλών',
    expandAll: 'Άνοιγμα Όλων',
    collapseAll: 'Κλείσιμο Όλων',
    copy: 'Αντιγραφή',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Αντιγραφή με Κεφαλίδες',
    copyWithGroupHeaders: 'Αντιγραφή με Κεφαλίδες Ομάδας',
    paste: 'Επικόλληση',
    ctrlV: 'Ctrl+V',
    export: 'Εξαγωγή',
    csvExport: 'Εξαγωγή σε CSV',
    excelExport: 'Εξαγωγή σε Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Άθροισμα',
    min: 'Ελάχιστο',
    max: 'Μέγιστο',
    none: 'Κανένα',
    count: 'Πλήθος',
    avg: 'Μέση τιμή',
    filteredRows: 'Φιλτραρισμένο',
    selectedRows: 'Επιλεγμένο',
    totalRows: 'Σύνολο σειρών',
    totalAndFilteredRows: 'Σειρές',
    more: 'Περισσότερα',
    to: 'to',
    of: 'από',
    page: 'Σελίδα',
    nextPage: 'Επόμενη σελίδα',
    lastPage: 'Τελευταία σελίδα',
    firstPage: 'Πρώτη σελίδα',
    previousPage: 'Προηγούμενη σελίδα',

    // Pivoting
    pivotColumnGroupTotals: 'Σύνολο',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Συγκεντρωτικό γράφημα & Λειτουργία Συγκεντρωτικού',
    pivotChart: 'Συγκεντρωτικό γράφημα',
    chartRange: 'Εύρος γραφήματος',

    columnChart: 'Στήλη',
    groupedColumn: 'Ομαδοποιημένα',
    stackedColumn: 'Στοιβαγμένα',
    normalizedColumn: '100% Στοιβαγμένα',

    barChart: 'Ραβδόγραμμα',
    groupedBar: 'Ομαδοποιημένα',
    stackedBar: 'Στοιβαγμένα',
    normalizedBar: '100% Στοιβαγμένα',

    pieChart: 'Γράφημα πίτας',
    pie: 'Πίτα',
    doughnut: 'Ντόνατ',

    line: 'Γραμμή',

    xyChart: 'X Y (Γράφημα διασποράς)',
    scatter: 'Γράφημα διασποράς',
    bubble: 'Φυσαλίδα',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',

    // ARIA
    ariaHidden: 'κρυμμένο',
    ariaVisible: 'ορατό',
    ariaChecked: 'τσεκαρισμένο',
    ariaUnchecked: 'μη τσεκαρισμένος',
    ariaIndeterminate: 'ακαθόριστο',
    ariaColumnSelectAll: 'Εναλλαγή επιλογής όλων των στηλών',
    ariaInputEditor: 'Επεξεργαστής Εισαγωγής',
    ariaDateFilterInput: 'Φίλτρο ημερομηνίας',
    ariaFilterInput: 'Εισαγωγή φίλτρου',
    ariaFilterColumnsInput: 'Εισαγωγή Φίλτρου Στήλης',
    ariaFilterValue: 'Τιμή φίλτρου',
    ariaFilterFromValue: 'Φίλτρο από τιμή',
    ariaFilterToValue: 'Φίλτρο σε τιμή',
    ariaFilteringOperator: 'Σύμβολο Φίλτρου',
    ariaColumn: 'Στήλη',
    ariaColumnGroup: 'Ομάδα στηλών',
    ariaRowSelect: 'Πατήστε SPACE για να επιλέξετε αυτή τη σειρά',
    ariaRowDeselect: 'Πατήστε SPACE για να καταργήσετε την επιλογή αυτής της σειράς',
    ariaRowToggleSelection: 'Πατήστε Space για εναλλαγή της επιλογής σειράς',
    ariaRowSelectAll: 'Πατήστε το Space για να αλλάξετε την επιλογή όλων των σειρών',
    ariaToggleVisibility: 'Πατήστε SPACE για εναλλαγή της ορατότητας',
    ariaSearch: 'Αναζήτηση',
    ariaSearchFilterValues: 'Αναζήτηση τιμών φίλτρου',

    // ARIA LABEL FOR DIALOGS
    ariaLabelColumnMenu: 'Μενού στήλης',
    ariaLabelCellEditor: 'Επεξεργαστής κελιών',
    ariaLabelDialog: 'Διάλογος',
    ariaLabelSelectField: 'Επιλέξτε Πεδίο',
    ariaLabelTooltip: 'Εργαλείο Επεξήγησης',
    ariaLabelContextMenu: 'Κατάλογος συμφραζόμενων',
    ariaLabelSubMenu: 'Υπομενού',
    ariaLabelAggregationFunction: 'Συνάρτηση Συνάθροισης'

}

export default AG_GRID_LOCALE_EL